export default __webpack_public_path__ + "static/media/avatar.442eea1a.png";